import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export interface VendorNote {
  id: string;
  vendor_id: string;
  company_id: string;
  content: string;
  created_by: string | null;
  created_at: string;
}

export const useVendorNotes = (vendorId?: string) => {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["vendor_notes", vendorId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("vendor_notes")
        .select("*")
        .eq("vendor_id", vendorId!)
        .order("created_at", { ascending: false });
      if (error) throw error;
      return (data ?? []) as unknown as VendorNote[];
    },
    enabled: !!user && !!vendorId,
  });
};

export const useCreateVendorNote = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: { vendor_id: string; content: string }) => {
      const { data: companyId, error: cidErr } = await supabase.rpc("my_company_id");
      if (cidErr) throw cidErr;
      const userId = (await supabase.auth.getUser()).data.user?.id;
      const { error } = await supabase
        .from("vendor_notes")
        .insert({
          vendor_id: input.vendor_id,
          company_id: companyId,
          content: input.content,
          created_by: userId,
        } as any);
      if (error) throw error;
    },
    onSuccess: (_d, vars) => {
      qc.invalidateQueries({ queryKey: ["vendor_notes", vars.vendor_id] });
    },
  });
};
